import React from 'react';
import type { Color } from '../../styles/variables';
import { COLORS } from '../../styles/variables';

interface CautionIconProps {
  size?: number;
  color?: Color;
}

const CautionIcon: React.FC<CautionIconProps> = ({ color = COLORS.error }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21.5,20.5 L1.5,20.5 L11.5,2.5 L21.5,20.5 Z M11.5,16 L11.5,18 M11.5,8 L11.5,14"
      stroke={color}
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    />
  </svg>
);

export default CautionIcon;
